import React from 'react';

/**
 * Mirrors Foundation/Common _Price.cshtml markup and classes for React consumers.
 */
const Price = ({ price }) => {
  if (!price) {
    return null;
  }

  const hasDiscount = price.DiscountPrice > 0;
  const discountFormatted = hasDiscount ? (price.DiscountPriceFormatted || '').trim() : '';
  const priceFormatted = price.Price > 0 ? (price.PriceFormatted || '').trim() : '';

  return (
    <span className="price mb-0 rpa-product-price">
      {hasDiscount ? <span className="visually-hidden">{price.SalePriceText}</span> : null}
      <span className="discount-price-value pe-1" data-defaultprice={hasDiscount ? discountFormatted : ''}>
        {hasDiscount ? discountFormatted : ''}
      </span>
      {hasDiscount ? <span className="visually-hidden">{price.OriginalPriceText}</span> : null}
      <span
        data-defaultprice={price.Price > 0 ? priceFormatted : ''}
        className={` price-value${hasDiscount ? ' discounted' : ''}`}
      >
        {priceFormatted}
      </span>
      {hasDiscount ? <div className="discount-price--saved d-block">({price.Save})</div> : null}
      <span className="d-none ga-price">{price.Price}</span>
      <span className="d-none ga-discount-price">{price.DiscountPrice === 0 ? '' : price.DiscountPrice}</span>
      <span className="d-none currencycode">{price.CurrencyCode}</span>
      <span className="d-none ga-minimum-price-rrp">{price.MinimumRRP === 0 ? '' : price.MinimumRRP}</span>
      <span className="d-none ga-minimum-discount-price-rrp">
        {price.DiscountMinimumRRP === 0 ? '' : price.DiscountMinimumRRP}
      </span>
      {price.ShowLast30DaysPrice && price.Last30DaysPrice ? (
        <div className="paragraph--xs">{price.Last30DaysPrice}</div>
      ) : null}
    </span>
  );
};

export default Price;
